export default {
  empty: 'Nenašli sa žiadne inštancie dielov.',
  addPart: 'Pridať diel',
  editPart: 'Upraviť diel',
  createOrder: 'Vytvoriť objednávku',
  selectOrder: 'Vyberte objednávku (voliteľné)',
  selectRevision: 'Vyberte revíziu dielu',
  confirmDelete: 'Odstrániť diel "{part}" z tejto vsádzky?',
};
